import { ComponentType, Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { EshavaDialogAnimationRef, EshavaDialogRef, eshavaDialogData } from '../models';

export interface DialogConfig {
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class EshavaDialogService {
  constructor(private _overlay: Overlay, private _injector: Injector) { }

  public open<T>(component: ComponentType<T>, config?: DialogConfig): EshavaDialogRef {
    const positionStrategy = this._overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();

    const overlayRef = this._overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'overlay-backdrop',
      panelClass: 'overlay-panel'
    });

    const animationRef = new EshavaDialogAnimationRef();
    const dialogRef = new EshavaDialogRef(overlayRef, animationRef);

    const injector = Injector.create({
      parent: this._injector,
      providers: [
        { provide: EshavaDialogRef, useValue: dialogRef },
        { provide: EshavaDialogAnimationRef, useValue: animationRef },
        { provide: eshavaDialogData, useValue: config?.data }
      ]
    });
    const portal = new ComponentPortal(component, null, injector);
    overlayRef.attach(portal);

    return dialogRef;
  }
}
